import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { bookingRoutes } from './bookings/bookings.routes';
import { CounterComponent } from './counter/counter.component';
import { CustomerComponent, EditCustomerComponent } from './customers/';
import { ListCustomersComponent } from './customers/list-customers/list.customers.component';
import { docketRoutes } from './docket/dockets.routes';
import { HirelogicComponent } from './hirelogic.component';
import { repairDocketRoutes } from './repair-docket/repair-docket.routing';
import { reportRoutes } from './report/report.routes';
import { saleDocketRoutes } from './sale-docket/sale-docket.routing';
import { settingsRoute } from './settings/settings.routes';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { AddUserComponent, EditUserComponent, UserComponent } from './user/';
import { WelcomeComponent } from './welcome/welcome.component';
import { dashboardRoutes } from './dashboard/dashboard.routes';
import { SignUpRoutes } from './auth/sign-up/sign-up.routes';
import { workshopRoutes } from './workshop/workshop.routes';
export const routes: Routes = [
  {
    path: 'counter',
    component: CounterComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService],
    title: 'Counter'
  },
  {
    path: 'epos',
    loadChildren: () => import('./epos/epos.routes').then((m) => m.eposRoutes),
    title: 'Epos'
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    component: HirelogicComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        title: 'Dashboard',
        children: dashboardRoutes
      },
      {
        path: 'customers',
        component: ListCustomersComponent,
        title: 'Customers'
      },
      {
        path: 'customer/:customerId',
        component: CustomerComponent,
        title: 'View Customer'
      },
      {
        path: 'customer/:customerId/edit',
        component: EditCustomerComponent,
        title: 'Edit Customer'
      },
      { path: 'users', component: UserComponent, title: 'Users' },
      { path: 'users/add', component: AddUserComponent, title: 'Add User' },
      {
        path: 'users/:userId',
        component: EditUserComponent,
        title: 'Edit USer'
      },
      { path: 'welcome', component: WelcomeComponent, title: 'Welcome' },
      {
        path: 'product',
        loadChildren: () =>
          import('./products/product.routes').then((m) => m.productRoutes),
        title: 'Products'
      },
      {
        path: 'reports',
        children: reportRoutes,
        title: 'Reports'
      },
      {
        path: 'docket',
        children: docketRoutes,
        title: 'Hire Contract'
      },
      {
        path: 'bookings',
        children: bookingRoutes,
        title: 'Booking'
      },
      {
        path: 'settings',
        children: settingsRoute,
        title: 'Settings'
      },
      {
        path: 'sale-docket',
        children: saleDocketRoutes,
        title: 'Sale Invoice'
      },
      {
        path: 'repair-docket',
        children: repairDocketRoutes,
        title: 'Repair Invoice'
      },
      {
        path: 'workshop',
        children: workshopRoutes,
        title: 'Workshop'
      }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./auth/sign-up/sign-up.routes').then((m) => m.SignUpRoutes)
  }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(
  routes,
  {}
);
